import { render, staticRenderFns } from "./ricercaPerCodArticolo.vue?vue&type=template&id=21655b16&"
import script from "./ricercaPerCodArticolo.vue?vue&type=script&lang=js&"
export * from "./ricercaPerCodArticolo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports